import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  NavLink,
  Button,
  Input,
  TextArea
} from '../'

class EmployerDivisionTableRow extends React.PureComponent {
  static propTypes = {
    division: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      notes: PropTypes.string
    })
  }

  state = {
    editMode: false,
    saveInProgress: false,
    name: null,
    notes: null
  }

  toggleEdit = () => this.setState(prevState => (
    prevState.editMode
      ? this.setState({ editMode: false })
      : this.setState({
          editMode: true,
          name: this.props.division.name,
          notes: this.props.division.notes
        })
  ))

  handleSave = () => {
    let division = this.props.division
    let input = {
      id: division.id
    }

    if (division.name !== this.state.name)
      input.name = this.state.name

    if (division.notes !== this.state.notes)
      input.notes = this.state.notes

    this.props.updateDivision({ variables: { input } })
      .then(this.toggleEdit)
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  anyValueChanged = () => (
    this.state.name !== this.props.division.name ||
    this.state.notes !== this.props.division.notes
  )

  render() {
    let division = this.props.division
    let { editMode, saveInProgress, name, notes } = this.state

    if (editMode) {
      return (
        <tr className='slds-hint-parent slds-size_1-of-1'>
          <td className='slds-size_1-of-4' role='gridcell'>
            <div className='slds-truncate' title={this.props.name}>
              <Input
                id='name'
                placeholder='Division name'
                value={name}
                onChange={this.handleChange}
               />
            </div>
          </td>
          <td className='slds-size_1-of-2' role='gridcell'>
            <div
              title={this.props.notes}
              style={this.props.notes && this.props.notes.trim().length > 0
                ? { whiteSpace: 'pre-wrap' }
                : {}
              }>
              <TextArea
                id='notes'
                placeholder='Division notes'
                value={notes}
                onChange={this.handleChange}
               />
            </div>
          </td>
          <td className='slds-size_1-of-4' role='gridcell'>
            <div className='slds-float_right slds-p-right_large'>
              <Button
                onClick={this.toggleEdit}
                minWidth={100}>
                Cancel
              </Button>
              <Button
                type='brand'
                onClick={this.handleSave}
                disabled={saveInProgress || !this.anyValueChanged()}
                minWidth={100}>
                {saveInProgress
                  ? 'Saving...'
                  : 'Save'
                }
              </Button>
            </div>
          </td>
        </tr>
      )
    } else {
      return (
        <tr className='slds-hint-parent slds-size_1-of-1'>
          <th className='slds-size_1-of-4' scope='row'>
            <div className='slds-truncate' title={division.name}>
              <NavLink to={`/os/identity/${division.employer.identity.id}/divisions/${division.id}`} >
                {division.name}
              </NavLink>
            </div>
          </th>
          <td className='slds-size_1-of-2' role='gridcell'>
            <div
              title={division.notes}
              style={division.notes && division.notes.trim().length > 0
                ? { whiteSpace: 'pre-wrap' }
                : {}
              }>
              {division.notes}
            </div>
          </td>
          <td className='slds-size_1-of-4' role='gridcell'>
            <div className='slds-float_right slds-p-right_large'>
              <Button
                onClick={this.toggleEdit}
                minWidth={100}>
                Edit
              </Button>
            </div>
          </td>
        </tr>
      )
    }
  }
}

const updateDivision = gql`
  mutation($input: DivisionMutationInput!) {
    divisionMutate(input: $input) {
      division {
        ...DivisionInformation
      }
    }
  }
  ${fragments.divisionInformation}
`

const withDivisionMutate = graphql(updateDivision, { name: 'updateDivision' })

export default withDivisionMutate(EmployerDivisionTableRow)



// WEBPACK FOOTER //
// ./src/components/employer-divisions/EmployerDivisionTableRow.js